import { render } from "./ConfigsView.vue?vue&type=template&id=273e4b26"
import script from "./ConfigsView.vue?vue&type=script&lang=js"
export * from "./ConfigsView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__